//eslint-disable import/first
import _ from 'lodash';

import React from 'react';
import UserItem from './UserItem';

const moment = require('moment');

class UserList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      display : true,
    }
  }

  toggeDisplay() {
    this.setState({
      display:!this.state.display
    })
  }

  renderConsultants(users) {

    
    var managers = _.uniqBy(_.map(users, 'sageContent.manager'), '_id')

    

    var dom = []
    _.each(managers.sort().reverse(), function(manager, i){

      

      var filteredUsers = _.filter(users, function(u){
        if(manager){
          return u.sageContent.manager && u.sageContent.manager._id === manager._id
        }else{
          return !u.sageContent.manager
        }
      })

  

      dom.push(
        <div key={i}>
          {manager ? (
            <div key={'manager'+i}>
              <h3 style={{marginTop:'30px'}}>{manager.sageContent.profile.firstName} {manager.sageContent.profile.lastName}</h3>
            </div>
          ) : (
            <div key={'manager'+i}>
              <h3 style={{marginTop:'30px'}}>Pas de Manager renseigné</h3>
            </div>
          )}

          {filteredUsers.map(data => <UserItem
            key={data._id+i}
            lastname={data.sageContent.profile.lastName}
            firstname={data.sageContent.profile.firstName}
            email={data.sageContent.email}
            active={data.active}
            id={data._id}
            //timestamp={moment(data.updatedAt).from(moment())}
            timestamp={moment(data.updatedAt).format('DD/MM/YYYY')}
          />)}
        </div>
      )
    })

    return (
      dom
    )
  }

  render() {
    return (
      <div className="list">
        {this.props.title === 'administrators' ?
          <h2 onClick={this.toggeDisplay.bind(this)} style={{marginTop: '0', marginBottom: '10px', cursor:'pointer'}}>{this.props.displayUsers.length} {this.props.title}</h2> : null
        }
        {this.props.title !== '' && this.props.title !== 'administrators'?
          <h2 onClick={this.toggeDisplay.bind(this)} style={{marginTop: '30px', marginBottom: '10px', cursor:'pointer'}}>{this.props.displayUsers.length} {this.props.title}</h2> : null
        }
        {this.state.display === true && this.props.title !== 'consultants' ? (
          <div>
            {this.props.displayUsers.map(data => <UserItem
              key={data._id}
              lastname={data.sageContent.profile.lastName}
              firstname={data.sageContent.profile.firstName}
              email={data.sageContent.email}
              active={data.active}
              id={data._id}
              //timestamp={moment(data.updatedAt).from(moment())}
              timestamp={moment(data.updatedAt).format('DD/MM/YYYY')}
            />)}
            </div>
          ) : (
            null
          )
        }
        {this.state.display === true && this.props.title === 'consultants' ? (
            this.renderConsultants(this.props.displayUsers)
          ) : (
            null
          )
        }
      </div>
    );
  }
}

export default UserList;
